module.exports = __webpack_public_path__ + "assets/img/37_1422_big.81a23547.jpg";